import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=61a9f96f&scoped=true&"
import script from "./RuleActions.vue?vue&type=script&lang=js&"
export * from "./RuleActions.vue?vue&type=script&lang=js&"
import style0 from "./RuleActions.vue?vue&type=style&index=0&id=61a9f96f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9f96f",
  null
  
)

export default component.exports